import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UpdateComponent } from '@app/shared/components/base/update.component';

@Component({
  selector: 'dr-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent extends UpdateComponent implements OnInit {

  @ViewChild('matCheckBox', { static: true }) checkboxRef;

  @Input()
  private boolValue: boolean;

  get pubBoolValue() {
    return this.boolValue;
  }

  set pubBoolValue(someBool: boolean) {
    // DO NOTHING
  }

  @Input()
  public patchPath: string;

  @Input()
  public label: string;

  @Input()
  public width?: number;

  @Input()
  public invalid?: boolean;

  constructor() {
    super();
    this._idPrefix = 'dr_checkbox.';
  }

  ngOnInit() {
    super.ngOnInit();
  }

  public toggleSelected(oldValue): void {
    if (!this.disabled) {
      this.boolValue = !oldValue;
      setTimeout(() => {
        this.checkboxRef._checked = !oldValue;
      }, 0);

      this.onChange(this.patchPath, !oldValue);
    }
  }

}
